import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RoutePaths } from 'src/app/routes/route-paths.enum';
import { CountryRepository } from 'src/app/entities/countries/state/country.repository';
import {
  COUNTRY_CODE_ROUTE_PARAM,
  CountryCode,
} from '@app-shared/enums/country-codes.enum';

export const countryCodeGuard: CanActivateFn = (route, state) => {
  const countryRepo = inject(CountryRepository);
  const router = inject(Router);

  const routeCountryParam: string = route.params[COUNTRY_CODE_ROUTE_PARAM];
  const codeFromRoute = routeCountryParam?.toUpperCase();
  const savedCode = countryRepo.getActiveCountry()?.country_code;

  const newCodeIsValid = countryRepo
    .getStoreProp('countryCodes')
    .includes(codeFromRoute);

  // check if there is a code saved in store and the new code from route is valid country code
  if (savedCode && newCodeIsValid) {
    // if user is on region portal and url changes to country portal, redirect user to region portal
    if (
      savedCode === CountryCode.REGION &&
      codeFromRoute !== CountryCode.REGION
    ) {
      router.navigate([countryRepo.getStoreProp('countryParam') + state.url]);

      return false;
    }

    // if code is the same as one already saved, allow navigation as the user is already going to a valid `/{code}/route` route
    if (savedCode === codeFromRoute) {
      return true;
    }
    // if code is not the same, set the new_code in store and navigate to new_code + route
    else {
      countryRepo.setCountryByCode(codeFromRoute);

      router.navigate([countryRepo.getStoreProp('countryParam') + state.url]);

      return false;
    }
  }
  // if there is a saved code, but new_code does not exists, navigate to saved_code + route
  else if (savedCode && !newCodeIsValid) {
    router.navigate([countryRepo.getStoreProp('countryParam') + state.url]);

    return false;
  }
  // if there is no saved code, but new_code exists, navigate to new_code + route
  else if (!savedCode && newCodeIsValid) {
    countryRepo.setCountryByCode(codeFromRoute);
    router.navigate([countryRepo.getStoreProp('countryParam') + state.url]);

    return false;
  }
  // if no code exists navigate to country selection route
  else {
    router.navigate(['/', RoutePaths.CountrySelection]);

    return false;
  }
};
